import React from "react";
import "../css/Participate.css";

// Иконки Bootstrap
import { 
  Clock, 
  Copy, 
  CheckCircle, 
  ArrowRight,
  Wallet,
  Send,
  QrCode
} from "react-bootstrap-icons";

import { QRCodeSVG } from "qrcode.react";
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Иконки криптовалют
import btc_icon from "../images/crypto/BTC.webp";
import eth_icon from "../images/crypto/ETH.png";
import xrp_icon from "../images/crypto/XRP.png";
import sol_icon from "../images/crypto/SOL.png";

const PartBox = ({ coin, address, icon, memo = false, min = 0.1 }) => {
  const copyToClipboard = async (text, label = 'Text') => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${label} copied to clipboard successfully!`);
    } catch (error) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      toast.success(`${label} copied to clipboard successfully!`);
    }
  };

  return (
    <div className="partbox">
      {/* Заголовок с иконкой и статусом */}
      <div className="partbox-header">
        <div className="coin-icon-wrapper">
          <img src={icon} alt={coin} className="coin-icon" />
        </div>
        <div className="partbox-title">
          <h4>{coin}</h4>
          <div className="status-badge">
            <Clock size={14} />
            <span>Waiting...</span>
          </div>
        </div>
      </div>

      {/* QR Code */}
      <div className="qr-wrapper">
        <QRCodeSVG 
          value={address} 
          imageSettings={{
            src: icon, 
            width: 32, 
            height: 32, 
            excavate: true
          }}
          className="qr-code"
        />
        <div className="qr-label">
          <QrCode size={16} />
          <span>Scan to pay</span>
        </div>
      </div>

      {/* Информация */}
      <div className="partbox-info">
        <p>
          Send your assets <strong>({coin})</strong> <br />
          <span className="min-amount">Minimum: {min} {coin}</span>
        </p>
      </div>

      {/* Адрес */}
      <div className="address-wrapper">
        <div className="address-label">
          <Wallet size={16} />
          <span>Wallet Address</span>
        </div>
        <div className="address-input">
          <span className="address-text">{address}</span>
          <button 
            className="copy-btn"
            onClick={() => copyToClipboard(address, address)}
          >
            <Copy size={18} />
          </button>
        </div>
      </div>

      {/* MEMO (если есть) */}
      {memo && (
        <div className="address-wrapper memo-wrapper">
          <div className="address-label">
            <Send size={16} />
            <span>Destination Tag (MEMO)</span>
          </div>
          <div className="address-input memo-input">
            <span className="address-text">182743</span>
            <button 
              className="copy-btn"
              onClick={() => copyToClipboard('182743', 'MEMO')}
            >
              <Copy size={18} />
            </button>
          </div>
        </div>
      )}

      {/* Кнопка копирования */}
      <button 
        className="partbox-action"
        onClick={() => copyToClipboard(address, address)}
      >
        <span>Copy Address</span>
        <ArrowRight size={18} />
        <div className="progress-bar">
          <div className="progress-line"></div>
        </div>
      </button>
    </div>
  );
};

export const Participate = ({ btc, eth, xrp, sol }) => {
  return (
    <div className="box _part" id="participate">
      <div className="container">
        <div className="participate-grid">
          <PartBox coin="BTC" address={btc} icon={btc_icon} min={0.1} />
          <PartBox coin="ETH" address={eth} icon={eth_icon} min={1} />
          <PartBox coin="XRP" address={xrp} icon={xrp_icon} min={1000} memo={true} />
          <PartBox coin="SOL" address={sol} icon={sol_icon} min={100} />
        </div>
      </div>
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        toastStyle={{
          backgroundColor: '#162a6b',
          color: '#ffffff',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: '500',
        }}
      />
    </div>
  );
};